import React, { useState, useEffect } from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import { YearBalanceCard } from '../YearBalanceCard/YearBalanceCard';

interface TransactionsYear {
  tscMonth: number;
  tscYear: number;
  totalIn: number;
  totalOut: number;
  balance: number;
  accumulatedBalance: number;
  projectedAccumulatedBalance: number;
}

interface YearBalanceListProps {
  transactions: TransactionsYear[];
  children: React.ReactNode; // Para receber a tabela original
}

export function YearBalanceList({ transactions, children }: YearBalanceListProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md')); // 768px
  const [shouldShowCards, setShouldShowCards] = useState(false);

  useEffect(() => {
    setShouldShowCards(isMobile);
  }, [isMobile]);

  if (shouldShowCards) {
    return (
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        gap: 2, 
        p: 2,
        width: '100%',
        minHeight: 200
      }}>
        {transactions.map((transaction) => (
          <YearBalanceCard
            key={`${transaction.tscYear}:${transaction.tscMonth}`}
            transaction={transaction}
          />
        ))}
      </Box>
    );
  }

  // Renderiza a tabela original no desktop
  return <>{children}</>;
}